import { CapsuleButton } from '@ui/components/CapsuleButton';

import { MemberStatus } from '@features/shared/api/typings';

type Props = {
  memberStatus?: MemberStatus;
  onClubJoin?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
};
export function ClubParticipationButton({ memberStatus, onClubJoin, isLoading, disabled }: Props) {
  if (isLoading) return null;

  if (!memberStatus) {
    return (
      <CapsuleButton
        preset="call-to-action"
        onClick={onClubJoin}
        disabled={disabled}
        shadow="weak"
        size="16m-40"
      >
        Присоединиться
      </CapsuleButton>
    );
  }

  if (memberStatus === 'JoinRequest') {
    return (
      <CapsuleButton size="16m-40" preset="hollow" disabled>
        Заявка в обработке
      </CapsuleButton>
    );
  }

  if (memberStatus === 'JoinRequestRejected') {
    return (
      <CapsuleButton size="16m-40" preset="hollow" disabled>
        Заявка отклонена
      </CapsuleButton>
    );
  }

  if (memberStatus === 'Deleted') {
    return (
      <CapsuleButton size="16m-40" preset="hollow" disabled>
        Доступ отозван
      </CapsuleButton>
    );
  }

  return null;
}
